// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --primary-color: #1565c0;
  --secondary-color: #0d47a1;
  --accent-color: #42a5f5;
  --light-bg: #f0f4f8;
  --dark-text: #333;
  --light-text: #fff;
  --border-radius: 10px;
  --box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.ProcessForm_formOverlay__mNyp\\+ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.ProcessForm_formContainer__SuvQn {
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  margin: 20px;
  background: #fff;
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.ProcessForm_formHeader__ALl4w {
  padding: 16px 20px;
  background: var(--primary-color);
  color: var(--light-text);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ProcessForm_formHeader__ALl4w h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}

.ProcessForm_closeButton__UkxHS {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: opacity 0.2s;
}
.ProcessForm_closeButton__UkxHS:hover {
  opacity: 1;
}

.ProcessForm_formContent__t2yrd {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
}

.ProcessForm_processNav__l4bYs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
}

.ProcessForm_processBtn__zUhHD {
  padding: 8px 15px;
  border-radius: 20px;
  font-size: 14px;
  transition: all 0.2s;
  background: none;
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
  cursor: pointer;
}
.ProcessForm_processBtn__zUhHD:hover {
  background: var(--primary-color);
  color: white;
}
.ProcessForm_processBtn__zUhHD.ProcessForm_active__zm-CA {
  background: var(--primary-color);
  color: white;
}

.ProcessForm_processPath__isOfj {
  margin-bottom: 20px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 6px;
  font-size: 14px;
}
.ProcessForm_processPath__isOfj .ProcessForm_pathItem__dnSIV {
  display: inline-block;
  color: var(--primary-color);
  font-weight: 500;
}
.ProcessForm_processPath__isOfj .ProcessForm_pathItem__dnSIV:not(:last-child)::after {
  content: "→";
  margin: 0 8px;
  color: #999;
}

.ProcessForm_questionCard__k84bw {
  border-left: 4px solid var(--accent-color);
  padding: 20px;
  margin-bottom: 30px;
  background-color: #fff;
  border-radius: var(--border-radius);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}
.ProcessForm_questionCard__k84bw:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}
.ProcessForm_questionCard__k84bw h3 {
  color: var(--primary-color);
  font-size: 18px;
  margin-bottom: 15px;
  font-weight: 600;
}

.ProcessForm_questionHeader__j5OpM {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
}
.ProcessForm_questionHeader__j5OpM h3 {
  margin: 0;
  flex: 1 1;
}

.ProcessForm_feedbackButton__lYIUt {
  background: #70ace9;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
}
.ProcessForm_feedbackButton__lYIUt:hover {
  background: #e9ecef;
  border-color: #adb5bd;
  color: #495057;
  transform: translateY(-1px);
}
.ProcessForm_feedbackButton__lYIUt:active {
  transform: translateY(0);
}

.ProcessForm_options__SFkFX {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ProcessForm_optionButton__j4EEz {
  display: block;
  width: 100%;
  text-align: left;
  padding: 12px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  overflow: hidden;
}
.ProcessForm_optionButton__j4EEz:hover {
  background-color: #f0f0f0;
  border-color: #d0d0d0;
}
.ProcessForm_optionButton__j4EEz.ProcessForm_selected__iDCNY {
  background-color: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.ProcessForm_resultCard__EAfx9 {
  background-color: #e8f5e9;
  border-radius: var(--border-radius);
  padding: 20px;
  margin-top: 20px;
  border-left: 4px solid #4caf50;
}
.ProcessForm_resultCard__EAfx9 h4 {
  color: #2e7d32;
  font-size: 18px;
  margin-bottom: 10px;
}
.ProcessForm_resultCard__EAfx9 p {
  color: #1b5e20;
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.5;
}
.ProcessForm_resultCard__EAfx9 p:last-child {
  margin-bottom: 0;
}

.ProcessForm_controls__NxtNq {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ProcessForm_controls__NxtNq .ProcessForm_backButton__DzuY9 {
  padding: 8px 16px;
  background: transparent;
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.ProcessForm_controls__NxtNq .ProcessForm_backButton__DzuY9:hover {
  background: var(--primary-color);
  color: white;
}

.ProcessForm_submitButton__Obz-A {
  padding: 12px 24px;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.ProcessForm_submitButton__Obz-A:hover {
  background: #388e3c;
}
.ProcessForm_submitButton__Obz-A:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.ProcessForm_completionCard__xOqEC {
  text-align: center;
  padding: 40px;
}
.ProcessForm_completionCard__xOqEC .ProcessForm_completionIcon__7SBWf {
  font-size: 48px;
  margin-bottom: 20px;
  animation: ProcessForm_bounce__4ONy6 1s infinite;
}
.ProcessForm_completionCard__xOqEC h3 {
  color: var(--primary-color);
  font-size: 24px;
  margin: 0 0 16px;
}

@keyframes ProcessForm_bounce__4ONy6 {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}
@media (max-width: 768px) {
  .ProcessForm_formContainer__SuvQn {
    margin: 0;
    max-height: 100vh;
    border-radius: 0;
  }
  .ProcessForm_questionCard__k84bw {
    padding: 15px;
  }
  .ProcessForm_optionButton__j4EEz {
    padding: 10px 15px;
  }
  .ProcessForm_controls__NxtNq {
    flex-direction: column;
    gap: 10px;
  }
  .ProcessForm_controls__NxtNq .ProcessForm_backButton__DzuY9 {
    width: 100%;
  }
}
.ProcessForm_loadingOverlay__UnFVO {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.ProcessForm_spinner__6S6M4 {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(21, 101, 192, 0.3);
  border-radius: 50%;
  border-top-color: var(--primary-color);
  animation: ProcessForm_spin__qGna9 1s linear infinite;
}

@keyframes ProcessForm_spin__qGna9 {
  to {
    transform: rotate(360deg);
  }
}
.ProcessForm_loadingMessage__6gUlI {
  text-align: center;
  padding: 40px;
}
.ProcessForm_loadingMessage__6gUlI h3 {
  color: var(--primary-color);
  font-size: 18px;
  margin-bottom: 10px;
}
.ProcessForm_loadingMessage__6gUlI p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.ProcessForm_debugInfo__Kc0hY {
  color: #d32f2f;
  font-size: 14px;
  padding: 10px;
  background-color: #ffebee;
  border-radius: 4px;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/ProcessForm/index.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,wBAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,wCAAA;AAEF;;AACA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAEF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mCAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAEF;;AACA;EACE,kBAAA;EACA,gCAAA;EACA,wBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAEF;AAAE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAEJ;;AAEA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,wBAAA;AACF;AACE;EACE,UAAA;AACJ;;AAGA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,sCAAA;EACA,2BAAA;EACA,eAAA;AAAF;AAEE;EACE,gCAAA;EACA,YAAA;AAAJ;AAGE;EACE,gCAAA;EACA,YAAA;AADJ;;AAKA;EACE,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAFF;AAIE;EACE,qBAAA;EACA,2BAAA;EACA,gBAAA;AAFJ;AAII;EACE,YAAA;EACA,aAAA;EACA,WAAA;AAFN;;AAOA;EACE,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,mCAAA;EACA,yCAAA;EACA,yBAAA;AAJF;AAME;EACE,yCAAA;EACA,2BAAA;AAJJ;AAOE;EACE,2BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AALJ;;AASA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AANF;AAQE;EACE,SAAA;EACA,SAAA;AANJ;;AAUA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAPF;AASE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,2BAAA;AAPJ;AAUE;EACE,wBAAA;AARJ;;AAYA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AATF;;AAYA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AATF;AAWE;EACE,yBAAA;EACA,qBAAA;AATJ;AAYE;EACE,sCAAA;EACA,YAAA;EACA,kCAAA;AAVJ;;AAcA;EACE,yBAAA;EACA,mCAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;AAXF;AAaE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AAXJ;AAcE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAZJ;AAcI;EACE,gBAAA;AAZN;;AAiBA;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAdF;AAgBE;EACE,iBAAA;EACA,uBAAA;EACA,sCAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;AAdJ;AAgBI;EACE,gCAAA;EACA,YAAA;AAdN;;AAmBA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAhBF;AAkBE;EACE,mBAAA;AAhBJ;AAmBE;EACE,gBAAA;EACA,mBAAA;AAjBJ;;AAqBA;EACE,kBAAA;EACA,aAAA;AAlBF;AAoBE;EACE,eAAA;EACA,mBAAA;EACA,gDAAA;AAlBJ;AAqBE;EACE,2BAAA;EACA,eAAA;EACA,gBAAA;AAnBJ;;AAuBA;EACE;IACE,wBAAA;EApBF;EAsBA;IACE,4BAAA;EApBF;AACF;AAuBA;EACE;IACE,SAAA;IACA,iBAAA;IACA,gBAAA;EArBF;EAwBA;IACE,aAAA;EAtBF;EAyBA;IACE,kBAAA;EAvBF;EA0BA;IACE,sBAAA;IACA,SAAA;EAxBF;EA0BE;IACE,WAAA;EAxBJ;AACF;AA4BA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AA1BF;;AA6BA;EACE,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,sCAAA;EACA,qDAAA;AA1BF;;AA6BA;EACE;IAAK,yBAAA;EAzBL;AACF;AA2BA;EACE,kBAAA;EACA,aAAA;AAzBF;AA2BE;EACE,2BAAA;EACA,eAAA;EACA,mBAAA;AAzBJ;AA4BE;EACE,WAAA;EACA,eAAA;EACA,SAAA;AA1BJ;;AA8BA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AA3BF","sourcesContent":[":root {\n  --primary-color: #1565c0;\n  --secondary-color: #0d47a1;\n  --accent-color: #42a5f5;\n  --light-bg: #f0f4f8;\n  --dark-text: #333;\n  --light-text: #fff;\n  --border-radius: 10px;\n  --box-shadow: 0 4px 15px rgba(0,0,0,0.1);\n}\n\n.formOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.formContainer {\n  width: 100%;\n  max-width: 900px;\n  max-height: 90vh;\n  margin: 20px;\n  background: #fff;\n  border-radius: var(--border-radius);\n  box-shadow: var(--box-shadow);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.formHeader {\n  padding: 16px 20px;\n  background: var(--primary-color);\n  color: var(--light-text);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  \n  h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 500;\n  }\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.8;\n  transition: opacity 0.2s;\n  \n  &:hover {\n    opacity: 1;\n  }\n}\n\n.formContent {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.processNav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.processBtn {\n  padding: 8px 15px;\n  border-radius: 20px;\n  font-size: 14px;\n  transition: all 0.2s;\n  background: none;\n  border: 1px solid var(--primary-color);\n  color: var(--primary-color);\n  cursor: pointer;\n  \n  &:hover {\n    background: var(--primary-color);\n    color: white;\n  }\n  \n  &.active {\n    background: var(--primary-color);\n    color: white;\n  }\n}\n\n.processPath {\n  margin-bottom: 20px;\n  padding: 10px;\n  background-color: #f5f5f5;\n  border-radius: 6px;\n  font-size: 14px;\n  \n  .pathItem {\n    display: inline-block;\n    color: var(--primary-color);\n    font-weight: 500;\n    \n    &:not(:last-child)::after {\n      content: \"→\";\n      margin: 0 8px;\n      color: #999;\n    }\n  }\n}\n\n.questionCard {\n  border-left: 4px solid var(--accent-color);\n  padding: 20px;\n  margin-bottom: 30px;\n  background-color: #fff;\n  border-radius: var(--border-radius);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n  transition: all 0.3s ease;\n  \n  &:hover {\n    box-shadow: 0 5px 15px rgba(0,0,0,0.1);\n    transform: translateY(-2px);\n  }\n  \n  h3 {\n    color: var(--primary-color);\n    font-size: 18px;\n    margin-bottom: 15px;\n    font-weight: 600;\n  }\n}\n\n.questionHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 16px;\n\n  h3 {\n    margin: 0;\n    flex: 1;\n  }\n}\n\n.feedbackButton {\n  background: #70ace9;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  padding: 8px 12px;\n  font-size: 12px;\n  color: #6c757d;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n\n  &:hover {\n    background: #e9ecef;\n    border-color: #adb5bd;\n    color: #495057;\n    transform: translateY(-1px);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n}\n\n.options {\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.optionButton {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 12px 20px;\n  border: 1px solid #e0e0e0;\n  border-radius: 6px;\n  background-color: #f9f9f9;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n  overflow: hidden;\n  \n  &:hover {\n    background-color: #f0f0f0;\n    border-color: #d0d0d0;\n  }\n  \n  &.selected {\n    background-color: var(--primary-color);\n    color: white;\n    border-color: var(--primary-color);\n  }\n}\n\n.resultCard {\n  background-color: #e8f5e9;\n  border-radius: var(--border-radius);\n  padding: 20px;\n  margin-top: 20px;\n  border-left: 4px solid #4caf50;\n  \n  h4 {\n    color: #2e7d32;\n    font-size: 18px;\n    margin-bottom: 10px;\n  }\n  \n  p {\n    color: #1b5e20;\n    margin-bottom: 8px;\n    font-size: 14px;\n    line-height: 1.5;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.controls {\n  margin-top: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  \n  .backButton {\n    padding: 8px 16px;\n    background: transparent;\n    border: 1px solid var(--primary-color);\n    color: var(--primary-color);\n    border-radius: 4px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    \n    &:hover {\n      background: var(--primary-color);\n      color: white;\n    }\n  }\n}\n\n.submitButton {\n  padding: 12px 24px;\n  background: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  \n  &:hover {\n    background: #388e3c;\n  }\n  \n  &:disabled {\n    background: #ccc;\n    cursor: not-allowed;\n  }\n}\n\n.completionCard {\n  text-align: center;\n  padding: 40px;\n  \n  .completionIcon {\n    font-size: 48px;\n    margin-bottom: 20px;\n    animation: bounce 1s infinite;\n  }\n  \n  h3 {\n    color: var(--primary-color);\n    font-size: 24px;\n    margin: 0 0 16px;\n  }\n}\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-10px);\n  }\n}\n\n@media (max-width: 768px) {\n  .formContainer {\n    margin: 0;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n  \n  .questionCard {\n    padding: 15px;\n  }\n  \n  .optionButton {\n    padding: 10px 15px;\n  }\n  \n  .controls {\n    flex-direction: column;\n    gap: 10px;\n    \n    .backButton {\n      width: 100%;\n    }\n  }\n}\n\n.loadingOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.8);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.spinner {\n  width: 50px;\n  height: 50px;\n  border: 5px solid rgba(21, 101, 192, 0.3);\n  border-radius: 50%;\n  border-top-color: var(--primary-color);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n.loadingMessage {\n  text-align: center;\n  padding: 40px;\n  \n  h3 {\n    color: var(--primary-color);\n    font-size: 18px;\n    margin-bottom: 10px;\n  }\n  \n  p {\n    color: #666;\n    font-size: 14px;\n    margin: 0;\n  }\n}\n\n.debugInfo {\n  color: #d32f2f;\n  font-size: 14px;\n  padding: 10px;\n  background-color: #ffebee;\n  border-radius: 4px;\n  margin-top: 10px;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formOverlay": `ProcessForm_formOverlay__mNyp+`,
	"formContainer": `ProcessForm_formContainer__SuvQn`,
	"formHeader": `ProcessForm_formHeader__ALl4w`,
	"closeButton": `ProcessForm_closeButton__UkxHS`,
	"formContent": `ProcessForm_formContent__t2yrd`,
	"processNav": `ProcessForm_processNav__l4bYs`,
	"processBtn": `ProcessForm_processBtn__zUhHD`,
	"active": `ProcessForm_active__zm-CA`,
	"processPath": `ProcessForm_processPath__isOfj`,
	"pathItem": `ProcessForm_pathItem__dnSIV`,
	"questionCard": `ProcessForm_questionCard__k84bw`,
	"questionHeader": `ProcessForm_questionHeader__j5OpM`,
	"feedbackButton": `ProcessForm_feedbackButton__lYIUt`,
	"options": `ProcessForm_options__SFkFX`,
	"optionButton": `ProcessForm_optionButton__j4EEz`,
	"selected": `ProcessForm_selected__iDCNY`,
	"resultCard": `ProcessForm_resultCard__EAfx9`,
	"controls": `ProcessForm_controls__NxtNq`,
	"backButton": `ProcessForm_backButton__DzuY9`,
	"submitButton": `ProcessForm_submitButton__Obz-A`,
	"completionCard": `ProcessForm_completionCard__xOqEC`,
	"completionIcon": `ProcessForm_completionIcon__7SBWf`,
	"bounce": `ProcessForm_bounce__4ONy6`,
	"loadingOverlay": `ProcessForm_loadingOverlay__UnFVO`,
	"spinner": `ProcessForm_spinner__6S6M4`,
	"spin": `ProcessForm_spin__qGna9`,
	"loadingMessage": `ProcessForm_loadingMessage__6gUlI`,
	"debugInfo": `ProcessForm_debugInfo__Kc0hY`
};
export default ___CSS_LOADER_EXPORT___;
